import type {ForestMassSpeciesRepository} from '@/domain/interfaces/ForestMassSpeciesRepository';

export class GetForestMassSpeciesBySpecieUuidUseCase {
  constructor(private readonly repository: ForestMassSpeciesRepository) {}
  async execute(uuid: string) {
    return this.repository.getBySpeciesUuid(uuid);
  }
}
